import styled from 'styled-components'

import '@ongov/ontario-design-system-design-tokens/dist/css/_variables.css'

export const ResultsOverviewText = styled.h1`
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 1rem;
  font-weight: var(--ontario-font-weights-normal);
  letter-spacing: 0;
  margin: var(--ontario-spacing-6) 0 var(--ontario-spacing-7);

  strong {
    font-weight: bolder;
  }

  .elaws-filter-text {
    margin-top: 2rem;
    max-width: 48rem;
  }
`

export default {ResultsOverviewText}
